import { planningAPI } from "../../axios";

export const actions = {
    CreatePTMT(context, data){
        return planningAPI.post(`PlanningTemplateMainTarget/Add`, data);
    },
    GetSinglePTMT(context, data){
        return planningAPI.get(`PlanningTemplateMainTarget/${data}`);
    },
    UpdatePTMT(context, data){
        return planningAPI.put(`PlanningTemplateMainTarget/Update/${data.id}`, data);
    },
    DeletePTMT(context, data){
        return planningAPI.delete(`PlanningTemplateMainTarget/Delete/${data}`);
    },
    GetPTMTByTemplate(context, data){
        return planningAPI.get(`PlanningTemplateMainTarget/PlanningTemplate/${data}`);
    },
    GetPTMTByTemplateAndIndicatorItem(context, data){
        return planningAPI.get(`PlanningTemplateMainTarget/PlanningTemplate/${data.templateId}/IndicatorItem/${data.indicatorItemId}`);
    },
    GetAllPTMTByIndicatorItem(context, data){
        return planningAPI.get(`PlanningTemplateMainTarget/All/${data}`);
    },
    GetAvailablePTMT(context, data){
        return planningAPI.get(`PlanningTemplateMainTarget/Available/PlanningTarget/${data.id}/${data.cycle}`);
    },
    ImportPTMT(context, data){
        return planningAPI.post(`PlanningTemplateMainTarget/Import/PrePlanningTarget/${data.id}/${data.include}`);
    },
    TransferToAnotherKPI(context, data){
        return planningAPI.post(`PlanningTemplateMainTarget/Move/IndicatorItem/${data.id}`, data.array);
    }
}